module.exports = __webpack_public_path__ + "node_modules/.pnpm/registry.npmmirror.com+remixicon@2.5.0/node_modules/remixicon/fonts/remixicon.woff";